import { useEffect } from "react";

// Keeping track of application state
import { useSelector } from "react-redux";
import { selectMenuOpen } from "../redux/features/applicationState/applicationStateSlice";

import { ScrollDisable, ScrollEnable } from "../helpers/ScrollLock";

const useMobileMenuScrollLock = () => {
  const isMenuOpen = useSelector(selectMenuOpen);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    if (isMenuOpen && mediaQuery.matches) {
      ScrollDisable();
    } else {
      ScrollEnable();
    }
  }, [isMenuOpen]);
};

export { useMobileMenuScrollLock };
